import loadable from '@loadable/component';

export const namespace =
  'canalplus.block.oneshop.offer.subscription_offer_summary';
export const Component = loadable(
  () => import('./containers/SummaryContainer')
);
export { default as propsFormatter } from './propsFormatter';
